module.exports = __webpack_public_path__ + "media/images/static/offer/lp_s05-1_s-8dc97d3ee0fd5617edecb485932312d7.png";